import { Controller } from '@hotwired/stimulus';
import { EVENTO_CONTROLLER_CARGADO } from './application_controller';

/* global $ */
export default class extends Controller {
  connect() {
    const $element = $(this.element);
    this.$selectorProfesor = $element.find('#filtro_registros_profesor_id');
    this.$selectorEstructura = $element.find('#selector-estructura');
    this.reseteando = false;

    this.$selectorProfesor.on('change', () => {
      if (!this.reseteando) {
        this.#getSelectorEstructura().clear();
      }
    });

    if (!this.#getSelectorEstructura()) {
      this.$selectorEstructura.on(EVENTO_CONTROLLER_CARGADO, () => {
        this.#gestionarSelector();
      });
    } else {
      this.#gestionarSelector();
    }
  }

  #gestionarSelector() {
    if (this.selectorEstructuraConectado || !this.#getSelectorEstructura()) {
      return;
    }

    this.#getSelectorEstructura().on('option:selected', () => {
      this.reseteando = true;
      this.$selectorProfesor.val('');
      this.$selectorProfesor.trigger('change');
      this.reseteando = false;
    });

    this.selectorEstructuraConectado = true;
  }

  #getSelectorEstructura() {
    return window.Stimulus.getControllerForElementAndIdentifier(
      this.$selectorEstructura[0], 'selector-estructura',
    )?.component;
  }
}
